module.exports = __webpack_public_path__ + "static/media/Wee.95498814.mp3";